import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../../modules/accounting/trueUpInvoice';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.trueUpInvoiceIds **/
	/** @namespace state.maps.trueUpInvoice **/
	/** @namespace state.maps.user **/
	let trueUpInvoices = undefined;
	if (state.lists.trueUpInvoiceIds) {
		trueUpInvoices = _.map(state.lists.trueUpInvoiceIds, id => state.maps.trueUpInvoice[id]);
	}
	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		trueUpInvoices,
		userMap : state.maps.user,
		bulkCustomerMap : state.maps.bulkCustomer,
		quickbooksTermMap  : state.maps.quickbooksTerm,
		resourceMap : state.maps.resource,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchTrueUpInvoices : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
